import { Descendant } from 'slate'

export function getDefaultDescendantValue(text = '') {
  return [
    {
      type: 'paragraph',
      children: [{ text }],
    } as Descendant,
  ]
}

export function isDescendant(value: unknown): value is Descendant[] {
  if (typeof value !== 'string' && !Array.isArray(value)) {
    return false
  }
  try {
    if (typeof value === 'string') {
      const parsed = JSON.parse(value)
      return Array.isArray(parsed) && !!parsed[0] && typeof parsed[0] === 'object' && 'children' in parsed[0]
    } else {
      return Array.isArray(value) && !!value[0] && typeof value[0] === 'object' && 'children' in value[0]
    }
  } catch (err) {
    return false
  }
}

export function findTableIdsInDescendant(node: Descendant | Descendant[]): string[] {
  let tableIds: string[] = []

  if (Array.isArray(node)) {
    // Process array of nodes
    for (const n of node) {
      if (typeof n === 'object') {
        // Check for tbl property at this level
        if ('tbl' in n && n.tbl) {
          tableIds.push(n.tbl)
        }
        if ('children' in n) {
          // Recursively process children
          tableIds.push(...findTableIdsInDescendant(n.children))
        }
      }
    }
  } else {
    if (node && typeof node === 'object') {
      // Process single node
      if ('tbl' in node && node.tbl) {
        tableIds.push(node.tbl)
      }
      if ('children' in node) {
        tableIds.push(...findTableIdsInDescendant(node.children))
      }
    }
  }

  return [...new Set(tableIds)]
}

export function parseStringToDescendant(str = '') {
  if (typeof str !== 'string') {
    return getDefaultDescendantValue(str)
  }
  try {
    const parsed = JSON.parse(str)

    if (!isDescendant(parsed)) {
      return getDefaultDescendantValue(str)
    }
    return parsed as Descendant[]
  } catch (err) {
    return getDefaultDescendantValue(str)
  }
}

export function formatDescendantToString(descendant: Descendant[]) {
  return JSON.stringify(descendant)
}

/**
 * Converts legacy ActionInputdata format to Descendant[] format for backward compatibility
 * @param value - The value to convert (can be legacy format, string, or already Descendant[])
 * @param defaultText - The default text to use if value is null/undefined
 * @returns Descendant[] format suitable for VariableTextV2
 */
export function convertLegacyValueToDescendant(value: any, defaultText = ''): Descendant[] {
  // If it's already in Descendant[] format, return as is
  if (isDescendant(value)) {
    return value as Descendant[]
  }

  // Default fallback
  return getDefaultDescendantValue(defaultText)
}
